<ng-container *ngIf="!hideAll">
  <section class="mt-2">
    <span
      ><button class="btn btn-secondary mt-2" (click)="openProductCharForAddEdit()"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add</button></span
    >
    <table class="table table-hover white_box shadow" style="margin-top: 10px">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Event Name</th>
          <th scope="col">Event Description</th>
          <th scope="col">Sub Region</th>
          <th scope="col">Event Date</th>
          <th scope="col">Event Create By</th>
          <th scope="col">Event URL</th>
          <th scope="col">Image</th>
          <th scope="col">Interest Members</th>
          <th scope="col" class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of allAds; let i = index">
          <th scope="row">{{ i + 1 }}</th>
          <td>{{ item?.name }}</td>
          <td>{{ item?.description }}</td>
          <td>
            <div class="row">
              <ng-container *ngFor="let s of item?.subRegionList">
                <span class="sub-cate p-2 m-2">{{ s | titlecase}}</span>
              </ng-container>
            </div>
          </td>
          <td>{{ item?.eventDate | date : "dd/MM/yyyy" }}</td>
          <td>{{ item?.eventCreatedBy }}</td>
          <td>{{ item?.url }}</td>
          <td><img loading="lazy" style="height: 5rem" [src]="imgUrl + item.image" /></td>
          <td>{{ item?.registeredMembers }}</td>

          <td class="text-right">
            <section class="d-flex justify-content-center">
              <button class="btn btn-info" (click)="openProductCharForAddEdit(item)">
                <i class="fa fa-pencil" aria-hidden="true"></i>
                Edit
              </button>
              <button class="btn btn-secondary ml-2" (click)="openModal(item)"><i class="fa fa-users" aria-hidden="true"></i> Assign</button>
              <button class="btn btn-danger ml-2" (click)="deleteAds(item?.id)"><i class="fa fa-trash" aria-hidden="true"></i> Delete</button>
            </section>
          </td>
        </tr>
      </tbody>
    </table>
  </section>
</ng-container>

<ng-template #addEvent let-modal>
  <form [formGroup]="form">
    <div class="upload-image">
      <input type="file" (change)="saveProductCharSelectedImage($event)" accept="image/*" />
      <!-- <img loading="lazy" *ngIf="banner_image_url" [src]="banner_image_url" alt="Thumbnail Preview" /> -->
      <img loading="lazy" *ngIf="imageBase64" [src]="imageBase64" alt="" />
      <img loading="lazy" *ngIf="selectedAds?.image" [src]="imgUrl + selectedAds?.image" />
      <div *ngIf="!imageBase64">
        <svg viewBox="0 0 700 662" fill="none">
          <path d="M122.187 122.422C96.5625 148.047 79.1406 179.609 71.25 214.063H84.1406C98.8281 155.234 142.812 107.891 199.766 88.5156V75.3125C170.781 84.375 144.297 100.312 122.187 122.422Z" fill="var(--primary)" />
          <path d="M699.844 353.203C699.844 441.953 627.891 513.984 539.141 514.062H411.563V479.688H539.141C572.891 479.688 604.609 466.484 628.438 442.656C652.344 418.75 665.469 387.031 665.469 353.203C665.469 319.453 652.344 287.656 628.438 263.828C604.531 240 572.734 226.797 538.984 226.797C530 226.797 521.172 227.734 512.578 229.531C500.859 232.031 489.609 236.094 479.141 241.797C478.359 229.766 476.562 217.813 473.828 206.172V206.094C471.016 193.906 467.109 182.031 462.188 170.391C450.938 143.906 434.922 120.078 414.453 99.6094C393.984 79.1406 370.234 63.125 343.672 51.875C316.25 40.3125 287.109 34.375 257.031 34.375C226.953 34.375 197.813 40.2344 170.391 51.875C143.906 63.0469 120.078 79.1406 99.6094 99.6094C79.1406 120.078 63.125 143.906 51.875 170.391C40.2344 197.812 34.375 226.953 34.375 257.031C34.375 287.109 40.2344 316.25 51.875 343.672C63.0469 370.156 79.1406 393.984 99.6094 414.453C120.078 434.922 143.906 450.937 170.391 462.187C197.813 473.75 226.953 479.688 257.031 479.688H288.047V514.062H256.016C114.531 513.516 0 398.672 0 257.031C0 115.078 115.078 0 257.031 0C377.813 0 479.141 83.2813 506.641 195.547V195.625C517.109 193.516 527.891 192.344 538.984 192.344C627.813 192.422 699.844 264.375 699.844 353.203Z" fill="#39393A" />
          <path d="M491.25 427.656H473.594L356.016 310.078V661.328H343.516V310.234L226.016 427.656H208.359L349.766 286.25L491.25 427.656Z" fill="var(--primary)" />
        </svg>
        <div>Please select a Image to upload.</div>
      </div>
    </div>
    <div class="all-progress" [class.active]="uploadProgress > 0">
      <p>Uploading... {{ uploadProgress }}%</p>
      <div class="progress">
        <div class="progress-bar" role="progressbar" [style.width.%]="uploadProgress"></div>
      </div>
    </div>

    <div class="form-group">
      <label class="mb-0" for="exampleInputEmail1">Event Name </label>
      <input type="text" formControlName="name" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter Event Name" />
    </div>

    <div class="form-group">
      <label class="mb-0" for="exampleInputEmail1">Event Description </label>
      <textarea rows="3" placeholder="Enter Event Description" class="form-control" formControlName="description"></textarea>
    </div>

    <div class="form-group">
      <label class="mb-0" for="exampleInputEmail1">Event Date </label>
      <input type="text" formControlName="eventDate" class="form-control" [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" [ngModelOptions]="{ standalone: true }" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter Event Date" />
      <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
    </div>

    <div class="form-group">
      <label class="mb-0" for="exampleInputEmail1">URL </label>
      <input type="text" formControlName="url" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Enter URL" />
    </div>

    <div class="mt-3 text-right">
      <button class="my-button-3 error mr-2" (click)="modalDismissAll()"><i class="fa-solid fa-times"></i> Cancel</button>
      <button class="my-button-3" (click)="save()"><i class="fa-solid fa-save"></i> Save</button>
    </div>
  </form>
</ng-template>

<ng-template #AssignOption let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Assign</h4>
    <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
    <section>
      <div>Sub Region :</div>
      <div class="my-4 row d-flex justify-content-center">
        <ng-container *ngFor="let s of subRegionList">
          <span class="sub-cate p-2 m-2"> <input type="checkbox" [(ngModel)]="s.checked" /> {{ s.name }}</span>
        </ng-container>
      </div>
    </section>

    <duv class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="assignArticles()">Assign</button>
    </duv>
  </div>
</ng-template>
